import React, { useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { useForm } from 'react-hook-form';
import axios from 'axios';

import { request } from '../../../api';
import cancelPieceForm from '../cancel_piece_form';

import styles from './vtrg_three_columns.scss';

const VtrgThreeColumnsForm = ({ data, instanceType, instanceId, pieceType, slot, updatePiece, setActionLoading, ordn, afterUpdateVtrgPiece, getPieceForm }) => {
  const [successMsg, setSuccessMsg] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [disableBtns, setDisableBtns] = useState(false);
  const [values, setValues] = useState({
    bodyf: data && data.bodyf,
    bodys: data && data.bodys,
    bodyt: data && data.bodyt,
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (localData, e) => {
    setDisableBtns(true);
    if (ordn) {
      setActionLoading(ordn);
    }
    
    // TODO костыль
    //console.log(e.action);
    //console.log(values);
    //console.log(localData);
    Object.keys(localData)
      .filter(key => key in values)
      .forEach(key => (localData[key] = values[key]));
    //
    
    axios
      .post(`${request}/vitrage/pieces/${slot ? slot : 'new'}`, localData)
      .then(response => {
        if (response.statusText === 'OK') {
          setSuccessMsg('Изменения успешно внесены');
          if ((!slot) && response.data.content) {
            getPieceForm(null);
            afterUpdateVtrgPiece(response.data.content);
          } else {
            afterUpdateVtrgPiece(localData);
          }
        } else {
          setErrorMsg('Произошли ошибки, пожалуйста попробуйте позже.');
        }
      })
      .catch(error => {
        console.log(error);
        setErrorMsg('Произошли ошибки, пожалуйста попробуйте позже.');
      })
      .finally(() => {
        setDisableBtns(false);
        setTimeout(() => {
          setSuccessMsg(null);
          setErrorMsg(null);
          updatePiece(null);
          setActionLoading(null);
        }, 500);
      });
  };

  const onError = (errors, e) => {
    console.log(errors);
    setErrorMsg('Произошла ошибка');
  };

  return (
    <div className="vtrg-edit-body">
      <h3>блок трёх колонок:</h3>
      <form
        onSubmit={handleSubmit(onSubmit, onError)}
        noValidate="novalidate"
        className="formtastic vitrage_pieces_vtrg_centered_image"
        encType="multipart/form-data"
        action={`${request}/vitrage/pieces/${slot ? slot : 'new'}}`}
        accept-charset="UTF-8"
        data-remote="true"
        method="post"
      >
        <fieldset className="inputs">
          <label>Содержание 1 колонки</label>
          <input type="hidden" />
          <Editor
            id="vitrage_pieces_vtrg_three_columns_bodyf"
            {...register('bodyf', { value: values.bodyf })}
            initialValue={data && data.bodyf}
            onEditorChange={newText => {
              setValues(values => {
                values.bodyf = newText;
                return values;
              })
            }}
            apiKey="d67jsxjoo87h4ff009q4p3uxwvoxl1k4ptvjr6l5qxfplr03"
            cloudChannel="dev"
            init={{
              plugins: 'paste',
              paste_preprocess: function(_, args) {
                args.content = args.content.replace(/&amp;/g, '&');
              }
            }}
          />
        </fieldset>
        <fieldset className="inputs">
          <label>Содержание 2 колонки</label>
          <Editor
            id="vitrage_pieces_vtrg_three_columns_bodys"
            initialValue={data && data.bodys}
            onEditorChange={newText => {
              setValues(values => {
                values.bodys = newText;
                return values;
              })
            }}
            {...register('bodys', { value: values.bodys })}
            apiKey="d67jsxjoo87h4ff009q4p3uxwvoxl1k4ptvjr6l5qxfplr03"
            cloudChannel="dev"
            init={{
              plugins: 'paste',
              paste_preprocess: function(_, args) {
                args.content = args.content.replace(/&amp;/g, '&');
              }
            }}
          />
        </fieldset>
        <fieldset className="inputs">
          <label>Содержание 3 колонки</label>
          <Editor
            id="vitrage_pieces_vtrg_three_columns_bodyt"
            initialValue={data && data.bodyt}
            onEditorChange={newText => {
              setValues(values => {
                values.bodyt = newText;
                return values;
              })
            }}
            {...register('bodyt', { value: values.bodyt })}
            apiKey="d67jsxjoo87h4ff009q4p3uxwvoxl1k4ptvjr6l5qxfplr03"
            cloudChannel="dev"
            init={{
              plugins: 'paste',
              paste_preprocess: function(_, args) {
                args.content = args.content.replace(/&amp;/g, '&');
              }
            }}
          />
        </fieldset>

        <input
          type="hidden"
          name="kind"
          value={pieceType}
          {...register('kind', { value: pieceType })}
        />
        <input
          type="hidden"
          name="owner_type"
          value={instanceType}
          {...register('owner_type', { value: instanceType })}
        />
        <input
          type="hidden"
          name="owner_id"
          value={instanceId}
          {...register('owner_id', { value: instanceId })}
        />

        {successMsg && <p className="success-hint">{successMsg}</p>}
        {errorMsg && <p className="error-hint">{errorMsg}</p>}
        {disableBtns && <span className="loading-hint"> Подождите ... </span>}

        <fieldset className={disableBtns ? 'actions_disable' : 'actions'}>
          <input type="submit" />
          <input
            type="reset"
            value="Отмена"
            onClick={() =>
              cancelPieceForm({ slot, updatePiece, afterUpdateVtrgPiece, getPieceForm })
            }
          />
        </fieldset>
      </form>
    </div>
  );
};

export default VtrgThreeColumnsForm;
